var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCardTemplateEye = function SvgIconCardTemplateEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 8.665a2.166 2.166 0 0 1 0-4.33 2.166 2.166 0 0 1 0 4.33Zm0-3.58c-.78 0-1.415.635-1.415 1.415S5.22 7.915 6 7.915 7.415 7.28 7.415 6.5 6.78 5.085 6 5.085Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 11.01c-1.88 0-3.655-1.1-4.875-3.01-.53-.825-.53-2.17 0-3C2.35 3.09 4.125 1.99 6 1.99S9.65 3.09 10.87 5c.53.825.53 2.17 0 3C9.65 9.91 7.875 11.01 6 11.01Zm0-8.27c-1.615 0-3.16.97-4.24 2.665-.375.585-.375 1.605 0 2.19C2.84 9.29 4.385 10.26 6 10.26c1.615 0 3.16-.97 4.24-2.665.375-.585.375-1.605 0-2.19C9.16 3.71 7.615 2.74 6 2.74Z"
  })));
};
export default SvgIconCardTemplateEye;